// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1JTKr","signatureButtonsRight":"ModalSign_signatureButtonsRight__3u28m"};